import queryString from 'query-string';

export function isAuthenticated() {
  token = queryString.parse(window.location.hash);
  window.location.hash = '';
  return !!token.access_token;
}

export function authenticate() {
  const authUrl =
    process.env.REACT_APP_IDENTITY_URL +
    'connect/authorize?client_id=' +
    process.env.REACT_APP_CLIENT_ID +
    '&response_type=id_token token' +
    '&redirect_uri=' +
    process.env.REACT_APP_CALLBACK_URL +
    '&scope=openid' +
    '&response_mode=fragment' +
    '&state=' +
    window.location.pathname +
    '&nonce=678910';

  window.open(authUrl, '_self');
}

export let token;
